<template>
    <form-row title="Has the survey been ordered?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_ordered_survey"
                v-model="has_ordered_survey"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_ordered_survey"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Ordered:"
                :value="attorney.ordered_survey_at"
                name="ordered_survey_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_ordered_survey: this.attorney.has_ordered_survey,
        }
    },
}
</script>
